// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ln4A","colBig":"styles_colBig__pOJ7T","colSmall":"styles_colSmall__34wOl","shopifyNameWrapper":"styles_shopifyNameWrapper__1tL9p"};